const GoldEarrings = [
  {
    id: 5,
    name: "Elegant Gold Hoop Earrings with Floral Accents",
    image: "images/earing2.JPG",
    price: 250,
    alt: "Elegant Gold Hoop Earrings with Floral Accents - Ideal for special occasions or gifting",
  },
  {
    id: 2,
    name: "Classic Gold Hoop Earrings for Daily Wear",
    image: "images/earing5.JPG",
    price: 350,
    alt: "Classic Gold Hoop Earrings for Daily Wear - Simple and versatile for everyday use",
  },
  {
    id: 4,
    name: "Traditional Gold Hoop Earrings with Ethnic Patterns",
    image: "images/earing1.JPG",
    price: 360,
    alt: "Traditional Gold Hoop Earrings with Ethnic Patterns - A perfect accessory to celebrate your heritage",
  },

  {
    id: 7,
    name: "Stylish Gold Hoop Earrings with Unique Textures",
    image: "images/earing3.JPG",
    price: 450,
    alt: "Stylish Gold Hoop Earrings with Unique Textures - Add sophistication to any outfit",
  },
  {
    id: 3,
    name: "Gold Hoop Earrings with Colorful Gemstones",
    image: "images/earing4.JPG",
    price: 450,
    alt: "Gold Hoop Earrings with Colorful Gemstones - Vibrant and stylish for a unique look",
  },
  {
    id: 6,
    name: "Classic Gold Hoop Earrings - The Essential Accessory",
    image: "images/earing6.JPG",
    price: 350,
    alt: "Classic Gold Hoop Earrings - The essential accessory for every gold jewelry collection",
  },
];

export default GoldEarrings;
